import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gray-900">
      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div>
            <h3 className="text-cyan-500 text-lg font-bold">Highline Apparel LLC</h3>
            <p className="mt-2 text-gray-300">
              Quality custom apparel for your business
            </p>
          </div>
          <div>
            <h3 className="text-cyan-500 text-lg font-bold">Get in Touch</h3>
            <p className="mt-2 text-gray-300">
              Ready to elevate your brand? Contact us through our online form and we'll get back to you promptly.
            </p>
            <Link
              to="/contact"
              className="inline-block mt-4 px-6 py-2 bg-cyan-500 text-black rounded-lg hover:bg-cyan-400 transition-colors"
            >
              Contact Us
            </Link>
          </div>
        </div>
        <div className="mt-8 border-t border-gray-800 pt-8 text-center">
          <p className="text-gray-400">
            © {new Date().getFullYear()} Highline Apparel LLC. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}